import React, { useEffect, useState } from "react";
import DataTableElement from "../../components/elements/DataTableElement";
import { useNavigate } from "react-router-dom";
import Columns from "./Columns";
import { categoriesResource, departmentsResource, productsResource } from "../../helpers/configRoutes/backend_helper";
import ModalNewSeller from "./ModalNewSeller";
import { useDispatch, useSelector } from "react-redux";
import { reset_product, update_product } from "../../store/products/action";
import CustomSelect from "../../components/form/CustomSelect";
import CustomSearchInput from "../../components/form/CustomSearchInput";
import FiltersPagination from "../../components/elements/FiltersPagination";

const Products = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [tableLoad, setTableLoad] = useState({ show: false, textLoad: 'Buscando ventas...' });
    const [filters, setFilters] = useState({
        page: 1,
        perPage: 15,
        department_id: '',
        category_id: '',
        search: ''
    });
    const [items, setItems] = useState([]);
    const [meta, setMeta] = useState({});
    const [rows, setRows] = useState([])
    const [modal, setModal] = useState({ show: false })

    const [categories, setCategories] = useState([]);
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        const getItems = async () => {
            const response = await productsResource('get', { params: filters });
            setItems(response.products);
            setMeta(response.meta)
        };
        getItems();
    }, [filters]);

    useEffect(() => {
        const getCatalogs = async () => {
            const responseCategories = await categoriesResource('get', { params: { select: true } });
            setCategories(responseCategories.categories);
            const responseDepartments = await departmentsResource('get', { params: { select: true } });
            setDepartments(responseDepartments.departments);
        };
        getCatalogs();
    }, []);

    const addUpd = async (product = false) => {
        if (product.id) {
            dispatch(update_product(product))
        } else {
            dispatch(reset_product())
        }
        setModal({ ...modal, show: true })
    }


    const handleUpload = async () => {
        const response = await productsResource('put', { products: rows, multiple: true }, 1);
        if (response.status) {
            setFilters({ ...filters })
        }
    }

    const cols = Columns(addUpd, categories, rows, setRows, setItems,items);
    const [loader, setLoader] = useState(false)
    const allRowsHaveCategory = rows.length > 0 && rows.every(r => !!r.category_id);

    return (
        <div className="flex flex-col w-full p-4 space-y-4">
            {/* Encabezado y botones arriba a la derecha */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div>
                    <h1 className="text-fr-dark text-2xl font-bold">Panel de Productos</h1>
                    <p className="text-fr-muted text-sm">Consulta y filtra productos por diferentes criterios</p>
                </div>

                <div className="flex gap-2">
                    <button
                        onClick={() => addUpd()}
                        className="flex items-center gap-2 bg-fr-primary text-white px-4 py-2 rounded-lg hover:bg-fr-primary-hover transition"
                    >
                        <span className="material-symbols-outlined text-base">add</span>
                        Nuevo vendedor
                    </button>
                </div>
            </div>
            <div className="bg-fr-light border border-fr-muted rounded-lg shadow-md p-4">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                    <div className="flex flex-wrap items-center gap-4 w-full lg:w-auto">
                        <p className="text-fr-dark font-medium">Filtrar por:</p>
                        <div className="min-w-[160px]">
                            <CustomSelect
                                isClearable={true}
                                className="text-sm"
                                holder="Area"
                                options={categories}
                                value={filters.category_id}
                                handleChange={(e) => setFilters({ ...filters, category_id: e.target.value })}
                            />
                        </div>
                        <div className="min-w-[160px]">
                            <CustomSelect
                                isClearable={true}
                                className="text-sm"
                                holder="Departamento"
                                options={departments}
                                value={filters.department_id}
                                handleChange={(e) => setFilters({ ...filters, department_id: e.target.value })}
                            />
                        </div>
                    </div>

                    <div className="flex items-center w-full lg:w-[300px]">
                        <CustomSearchInput
                            value={filters.search}
                            handleChange={(e) => setFilters({ ...filters, search: e.target.value })}
                            placeholder="Buscar..."
                        />
                    </div>
                </div>
            </div>
            {/* Tabla */}
            <FiltersPagination meta={meta} filters={filters} setFilters={setFilters} showFilters={false}>
                <DataTableElement columns={cols} tableLoad={tableLoad} items={items} />
            </FiltersPagination>
            {modal.show &&
                <ModalNewSeller filters={filters} setFilters={setFilters} modal={modal} setModal={setModal} />
            }
            {rows.length > 0 && (
                <button
                    onClick={handleUpload}
                    disabled={!allRowsHaveCategory || loader}
                    className={`fixed bottom-6 right-6 z-50 rounded-full w-16 h-16 flex items-center justify-center shadow-xl transition transform hover:scale-105
        ${allRowsHaveCategory
                            ? 'bg-fr-primary text-white hover:bg-fr-primary-hover'
                            : 'bg-red-500 text-white opacity-70 cursor-not-allowed'
                        }`}
                    title={
                        allRowsHaveCategory
                            ? "Guardar venta"
                            : "Debes asignar un área a todos los productos"
                    }
                >
                    {loader ? (
                        <span className="animate-spin material-symbols-outlined text-[24px]">sync</span>
                    ) : (
                        <span className="material-symbols-outlined text-[28px]">save</span>
                    )}
                </button>
            )}
        </div>
    );
};

export default Products;
